import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

const Game = () => {
  const [userChoice, setUserChoice] = useState("");
  const [computerChoice, setComputerChoice] = useState("");
  const [result, setResult] = useState("");

  const options = ["rock", "paper", "scissors"];

  const play = (userChoice) => {
    setUserChoice(userChoice);
    let randomNum = Math.floor(Math.random() * 3);
    let computerChoice = options[randomNum];
    setComputerChoice(computerChoice);
    determineWinner(userChoice, computerChoice);
  };

  const determineWinner = (user, computer) => {
    if (user === computer) {
      setResult("It's a tie!");
    } else if (
      (user === "rock" && computer === "scissors") ||
      (user === "paper" && computer === "rock") ||
      (user === "scissors" && computer === "paper")
    ) {
      setResult("You win!");
    } else {
      setResult("You lose.");
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center">Rock, Paper, Scissors</h1>
      <div className="d-flex justify-content-center">
        <div className="card game-card">
          <div className="card-header">Choose Your Weapon</div>
          <div className="card-body">
            <button
              className="btn btn-warning mr-3 game-btn"
              onClick={() => play("rock")}
            >
              Rock
            </button>
            <button
              className="btn btn-warning mr-3 game-btn"
              onClick={() => play("paper")}
            >
              Paper
            </button>
            <button
              className="btn btn-warning mr-3 game-btn"
              onClick={() => play("scissors")}
            >
              Scissors
            </button>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-5">
        <div className="card game-card">
          <div className="card-header">Results</div>
          <div className="card-body">
            <p>
              You chose: <b>{userChoice}</b>
            </p>
            <p>
              Computer chose: <b>{computerChoice}</b>
            </p>
            <p className="result">
              Result: <b>{result}</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;
